import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { LayoutService } from '../services/layout.service';

@Component({
    selector: "app-layout",
    templateUrl: "../views/layout.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class LayoutComponent implements OnInit {

    constructor() {

    }

    ngOnInit() {
      console.log('111');
    }
}
